import {fetchAllAircraftSuccess, fetchAllAircraftError, fetchAircraftPending } from "../redux/actions";

const fetchAircraftData = () => {
    return async dispatch => {
        dispatch(fetchAircraftPending());
        try {
            let res = await fetch('https://www.x-flightserver.org/yaam/get_webinfo.php?data=true')
            //let res = await fetch('//85.214.43.137:5000/data')
            //let res = await fetch('https://www.fsc-ev.de/yaam/get_webinfo.php?data=true')
            //let res = await fetch('http://127.0.0.1/yaam/get_webinfo.php?data=true')
            //let res = await fetch('http://127.0.0.1/airlines/get_data.php')
            res = await res.json();
            dispatch(fetchAllAircraftSuccess(res));
        } catch (error) {
            dispatch(fetchAllAircraftError(error));
        }
    }
}

export default fetchAircraftData;
